var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"layout-default"},[_c('main',{staticClass:"layout-default__main"},[_c('div',{staticClass:"layout-default__main-wrapper"},[_c('router-view')],1)]),_c('PBoToast')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }